import { useDebriefSelector, useDebriefRouter } from 'ff/debrief/hooks';

export function useDebriefStatus(tracklogId: string = null) {
    const router = useDebriefRouter();

    const selectedTracklogId = tracklogId || router.routeParams.tracklogId;

    const isReanalyzing = useDebriefSelector(
        s => s.statusSlice.tracks[selectedTracklogId]?.isReanalyzing ?? false
    );

    return {
        isReanalyzing: isReanalyzing,
    };
}
